import { interact, URLS } from "fire-wind-water";
import * as sbaseData from "../common/sbase";
import service from "../service/form";
export default {
  created() {
    window.$sk.loading.show();
    sbaseData.init();

    this.signSuccess = sbaseData.needVerify != 1;
    debugger;
    this.isRefuse = sbaseData.isRefuse;
    document.title = this.signSuccess
      ? "报名成功页"
      : this.isRefuse
      ? "报名未通过页"
      : "提交成功页";
    window.$sk.template.module(this);
  },
  computed: {
    hideLoad() {
      const { extras, seminarInfo } = this;
      return {
        extras,
        seminarInfo,
      };
    },
  },
  watch: {
    hideLoad: {
      handler: function (n) {
        console.log(
          "==============",
          Object.keys(n.extras).length,
          Object.keys(n.seminarInfo).length
        );
        if (Object.keys(n.extras).length && Object.keys(n.seminarInfo).length) {
          window.$sk.loading.hide();
        }
      },
    },
  },
  methods: {
    skUserEnd() {
      const info = window.$sk.template.get();
      this.tenantId = info.common.tenantId;
      this.user = info.user;
      if (this.getEventInfo) {
        this.getEventInfo();
      }
      if (sbaseData.isSetting) {
        this.initConfig();
        window.$sk.loading.hide();
        return;
      }
      this.customformGet();
    },
    customformGet() {
      service
        .getCustomform({
          customFormId: sbaseData.customFormId,
          tenantId: this.tenantId,
          linkId: sbaseData.linkId,
          globalUserId: this.user.globalUserId,
        })
        .subscribe((data) => {
          if (data.result == 0) {
            this.formInfo = data.content;
            this.initConfig();
            this.initWeChatShare();
          } else {
            window.$sk.tips.show(data.desc);
          }
          //window.$sk.loading.hide();
        });
    },

    //获取联系人的报名状态
    getSignUpStatus() {
      const param = {
        instanceId: sbaseData.instanceId,
        formId: sbaseData.customFormId,
        sess: this.user.session,
        openId: this.user.openId,
        needSignupUrl: "0",
        globalUserId: this.user.globalUserId,
      };
      service.canRegisterNew(param).then((data) => {
        this.category = data.content.category;
        if (data.content.markCode && this.posterUrl) {
          this.posterUrl = `${this.posterUrl}&markCode=${data.content.markCode}`;
        }
        if (data.content.signupStatus === "allow") {
          window.location.hash = "#/";
        }
      });
    },
    initWeChatShare() {
      if (!interact.isWeChat) {
        return;
      }
      const formInfo = this.formInfo;
      let url = URLS.removeSearchParam(
        window.location.href,
        "token",
        "retCode",
        "puzzleFlag",
        "excode",
        "loadcount",
        "scope"
      );
      url = url.split("#")[0] + "#/";
      const shareInfo = {
        title: formInfo.shareTitle || formInfo.title, // 分享标题,
        desc: formInfo.shareDesc || "", // 分享描述,
        link: sbaseData.weChatId
          ? window.config.weChatOauthUrl +
            "?weChatId=" +
            sbaseData.weChatId +
            "&scope=&return_url=" +
            encodeURIComponent(url)
          : url,
        imgUrl: formInfo.shareImageRealPath
          ? "https:" + formInfo.shareImageRealPath
          : "", // 分享图标
      };
      window.$swxsdk.initWxSdk(
        { tenantId: formInfo.tenantId, weChatId: formInfo.attachWXAccount },
        window.apiUrl
      );
      window.$swxsdk.on("sharer", shareInfo);
      window.$swxsdk.on("sharer_friends", shareInfo);
    },

    /* 跳转到海报 邀请函页面 */
    goInvite() {
      if (
        this.posterInfo.poster.status == undefined &&
        this.posterInfo.poster.wap != undefined &&
        this.posterUrl
      ) {
        window.$sk.goto(this.posterUrl);
      }
    },
  },
};
